export default {
  barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
  barImage:
    'https://res.cloudinary.com/dkod5pdlc/image/upload/v1631419665/terapiacl/admin/fondos/lock_ryujar.jpg',
  drawerAdmin: null,
  slidersAdmin: null,
}
